export default __webpack_public_path__ + "static/AndorRegular-PersonalUse-91f6025bb78a023817d66db7ce3d3e85.ttf";